import { colorByRiskLevelIndicator, RiskLevelIndicator } from "../riskLevels/riskLevelIndicators";

const emptyCellColor = "#EFEFEF";

// A cell takes the color of the indicator chosen for its risk level: the cell value (1..scale) indexes the
// risk-level indicators. Empty (cleared) cells fall back to a neutral placeholder.
export function riskCellColor(value: number | null, riskLevelIndicators: RiskLevelIndicator[]): string {
    if (value === null) return emptyCellColor;

    const indicator = riskLevelIndicators[value - 1];

    return indicator === undefined ? emptyCellColor : colorByRiskLevelIndicator[indicator];
}
